import { SaveType, BaseModel } from "@puntaje/shared/core"
import { BannerInstancia } from "./banner_instancias.model"

export class Universidad extends BaseModel {
    public universidad: string
}
